<ca-circular-loader [progress]="progress">
  <ng-template>
    <ca-image-loader
      tappable
      [background]="!!url"
      [image]="url"
    ></ca-image-loader>
  </ng-template>
</ca-circular-loader>
